import { css } from '@/styled-system/css';

export const menuItemWithIconStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});
